import { Component, OnInit ,ViewChild} from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { GroupService } from "./shared/group.service";
import { CenterlinkService } from "../../customer/shared/centerlink.service";

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css']
})
export class GroupComponent implements OnInit {

  AddButtonText: string ;
  ErrorText: string;
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  divDetails:boolean;
  ParentGroupNo: number;
  CenterList:[''];

  constructor(private router: Router,private activatedRoute:ActivatedRoute,
    public groupService: GroupService,
    private centerlinkService: CenterlinkService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentGroupNo = + param['Id'];  //Parent Group Id
    });
  
    this.divDetails =true;   
    this.GetCentreList(); 

    this.dataSourceList.paginator = this.paginator;
    this.resetForm();

    if (Number.isNaN(this.ParentGroupNo)) {
      this.groupService.selectedGroup.Id = 0;
      this.groupService.selectedGroup.Flag = 1;
      this.groupService.selectedGroup.IsActive = 1;
      this.AddButtonText = "Save";
    }
    else {
      this.groupService.selectedGroup.Id = +this.ParentGroupNo;
      this.groupService.selectedGroup.Flag = 2;
      // this.groupService.selectedGroup.IsActive = 1;
      this.AddButtonText = "Edit & Save";

      this.GetGroupByGroupId();      
    }  
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.groupService.selectedGroup = {
      Id: 0,
      GroupName: null,
      GroupLeaderName: null,
      GroupAsstLeaderName: null,
      CentreId : 0,
      MaxMembers : null,
      Details : null,
      EmployeeId : null,
      EmployeeBranchId : null,
      CompanyId : null,
      SaasId : null,
      IsActive : 0,
      Flag : 0,
    }
  }

  public onSubmit(form: NgForm) {
      this.groupService.IUDGroup(form.value)
      .toPromise()
      .then(data => {
        this.resetForm(form);
        this.router.navigate(['/grouplist']);
      })
      .catch(err => { console.log(err) });
  }

  GetGroupByGroupId() {

    if (!Number.isNaN(this.ParentGroupNo)) {
      this.groupService.selectedGroup.Id = this.ParentGroupNo;
      this.groupService.FetchGroupByGroupId(this.groupService.selectedGroup).subscribe(data => {
        // this.groupService.selectedGroup.Id=+data.Id;
        this.groupService.selectedGroup = data;
        this.groupService.selectedGroup.Flag = 2; // for edit
      })
    }
  }

  // GetCenterList(){
  //   this.groupService.GetCenterList().subscribe(data => {
  //     this.CenterList = data;
  //   })
  // }

  GetCentreList() {
    this.centerlinkService.GetCentreList()
    .toPromise()
    .then(data => {
      this.CenterList = data;
    })
  }

}
